import Locale from "./Locale";


export default Locale;